export function metersToKm(meters: number) {
  return Math.round(meters / 1000);
}
